<script lang="ts">
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { LinkButton } from '$global/components/LinkButton';
	import { Txt } from '$global/components/Txt';

	interface Props {
		imageUrl: string;
		dataCy: string;
	}

	let { imageUrl, dataCy }: Props = $props();

	let dataCyPrefix = $derived(`${dataCy}-private-sales-banner`);

	const textShadow =
		'text-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px, rgba(0, 0, 0, 0.1) 0px 1px 1px, rgba(0, 0, 0, 0.1) 0px 1px 8px';
</script>

<div
	class="relative w-full overflow-hidden rounded bg-gray-500 bg-cover bg-center"
	style={`background-image: url("${imageUrl}")`}
>
	<div class="flex flex-col items-center gap-3 px-4 py-12">
		<Txt class="text-center text-white uppercase" style={textShadow}
			>HENI Private Sales</Txt
		>

		<Txt
			variant="h4"
			class="mb-2 max-w-[500px] text-center font-semibold text-white lg:text-[2rem] lg:leading-[2.5rem]"
			style={textShadow}
		>
			Buy and sell from other collectors
		</Txt>

		<LinkButton
			size="sm"
			variant="secondary"
			dataCy={dataCyPrefix}
			href={GlobalRoutes.PrivateSalesHome}
			class="shadow"
		>
			Learn More
		</LinkButton>
	</div>
</div>
